import React from 'react'
import {CardHorizontal, CardVertical, CircleWithText, ReportTable, IntroCard, Tabs, DataBanner, AccordionComponent} from './components';

// Function to retrieve a component by its string type
export const getComponentByType = (componentType, content, index) => {
    switch (componentType) {
        case 'cardHorizontal':
            return <CardHorizontal key={index} cardData={content}/>;
        case 'cardVertical':
            return <CardVertical key={index} cardData={content}/>;
        case 'circleWithText':
            return <CircleWithText key={index} circleWithTextData={content}/>;
        case 'table':
            return <ReportTable key={index} tableData={content}/>;
        case 'introCard':
            return <IntroCard key={index} cardData={content}/>;
        case 'tabs':
            return <Tabs key={index} tabsInfo={content}/>;
        case 'dataBanner':
            return <DataBanner key={index} dataBanner={content}/>;
        case 'accordion':
            return <AccordionComponent key={index} content={content}/>;
        default:
            console.error(`Component with type "${componentType}" not found`);
            return null;
    }
};